import { render, staticRenderFns } from "./wizardcontent.vue?vue&type=template&id=24902ce4&"
import script from "../../ts/wizard/wizardcontent.ts?vue&type=script&lang=js&"
export * from "../../ts/wizard/wizardcontent.ts?vue&type=script&lang=js&"
import style0 from "../../assets/css/wizard/wizardcontent.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports